module.exports = __webpack_public_path__ + "static/background-33bfaecb960504be2974a33c6fe65d15.png";